/**
 * Account actions
 */
export enum AccountActionEnum {
	/**
	 * Set account status to active
	 */
	ACTIVATE = 'activate',

	/**
	 * Set account status to closed
	 */
	CLOSE = 'close',

	/**
	 * Set account status to on hold
	 */
	PUT_ON_HOLD = 'put_on_hold',
}
